
import './App.css';
import React, { useEffect, useState } from 'react';
import ReactModal from "react-modal";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "./context";
import CreateClient from "./Pages/CreateClient/CreateClient";
import SignIn from "./Pages/SignIn/SignIn";
import MainMenuPage from "./Pages/MainMenuPage/MainMenuPage";
import AllClients  from "./Pages/AllClients/AllClients";
import Employees from "./Pages/Employees/Employees";
import CreateUser from "./Pages/CreateUser/CreateUser";
import EditUser from "./Pages/EditUser/EditUser";
import EditClient from "./Pages/EditClient/EditClient";
import ClientInfo from "./Pages/ClientInfo/ClientInfo";
import ClientsBilling from "./Pages/BillingSheet/ClientsBilling";
import ClientBillingInfo from "./Pages/BillingSheet/ClientInfo";
import Activity from "./Pages/BillingSheet/Activity";
import Statistics from "./Pages/BillingSheet/Statistica/Statistica";
import EditClientInfo from "./Pages/BillingSheet/EditClientInfo";

function App() {

    ReactModal.setAppElement('#root');

    const {
        setRoles
    } = useGlobalContext()

    const navigate = useNavigate();
    const location = useLocation();
    const [token] = useState<string | undefined>(localStorage.getItem("reftkn") as string);

    useEffect(() => {
        const rolesString: string | null = localStorage.getItem("roles");
        if (rolesString !== null) {
            const roles: string[] = JSON.parse(rolesString);
            setRoles(roles);
        }
    }, [])

    useEffect(() => {
        if (token) {
            if (location.pathname === "/") {
                navigate("/main");
            }
        }
        else {
            navigate("/");
        }
    },[location.pathname])

    return (
        token ?
            <Routes>
                <Route path = { "/main" } element = { <MainMenuPage /> } />
                <Route path = { "/create-client" }  element = { <CreateClient/> } />
                <Route path = { "/clients" } element = { <AllClients/> } />
                <Route path = { "/employees" } element = { <Employees/> } />
                <Route path = { "/edit-client" } element = { <EditClient/> } />
                <Route path = { "/create-user" } element = { <CreateUser/> } />
                <Route path = { "/edit-user" } element = { <EditUser/> } />
                <Route path = { "/client-info" } element = { <ClientInfo/> } />
                <Route path = { "/billing-clients" } element = { <ClientsBilling/> } />
                <Route path = { "/billing-client-info" } element = { <ClientBillingInfo/> } />
                <Route path = { "/billing-activity" } element = { <Activity/> } />
                <Route path = { "/billing-statistics" } element = { <Statistics/> } />
                <Route path = { "/billing-edit-client" } element = { <EditClientInfo/> } />
            </Routes>
            :
            <Routes>
                <Route path = "/" element = { <SignIn/> } />
            </Routes>
    )
}

export default App


